'use client'

import { useEffect, useState, useCallback } from 'react'
import { CreditsBuyCreditsModal } from '@/components/dashboard/credits/CreditsBuyCreditsModal'
import { CreditsBuyEmailsModal } from '@/components/dashboard/credits/CreditsBuyEmailsModal'

export function BillingModalsProvider() {
  const [buyCreditsOpen, setBuyCreditsOpen] = useState(false)
  const [buyEmailsOpen, setBuyEmailsOpen] = useState(false)

  const openCredits = useCallback(() => setBuyCreditsOpen(true), [])
  const openEmails = useCallback(() => setBuyEmailsOpen(true), [])

  useEffect(() => {
    window.addEventListener('hubee:buy_credits_open', openCredits as EventListener)
    window.addEventListener('hubee:buy_emails_open', openEmails as EventListener)

    return () => {
      window.removeEventListener('hubee:buy_credits_open', openCredits as EventListener)
      window.removeEventListener('hubee:buy_emails_open', openEmails as EventListener)
    }
  }, [openCredits, openEmails])

  return (
    <>
      <CreditsBuyCreditsModal
        open={
          buyCreditsOpen
        }

        onOpenChange={
          setBuyCreditsOpen
        }

        onCreditsAdded={() => {
          window.dispatchEvent(
            new CustomEvent(
              'hubee:credits_refresh'
            )
          )

          window.dispatchEvent(
            new CustomEvent(
              'hubee:energy_refresh'
            )
          )
        }}
      />

      <CreditsBuyEmailsModal
        open={buyEmailsOpen}
        onOpenChange={setBuyEmailsOpen}
        onEmailsUpdated={() => {
          window.dispatchEvent(new CustomEvent('hubee:emails_refresh'))
        }}
      />
    </>
  )
}